export default __webpack_public_path__ + "static/media/quiz_bg.becd68a9.png";